import React, { useState } from 'react';
import { 
  Paper, 
  Typography, 
  TextField, 
  Button, 
  Container, 
  Box, 
  makeStyles, 
  InputAdornment, 
  IconButton,
  Divider,
  Grid
} from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { Visibility, VisibilityOff, LockOutlined } from '@material-ui/icons';
import { useApiKey } from '../context/ApiKeyContext';

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  paper: {
    padding: theme.spacing(4),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    maxWidth: 500,
    margin: '0 auto',
  },
  formField: {
    marginBottom: theme.spacing(3),
    width: '100%'
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.primary.main,
  },
  icon: {
    fontSize: 40,
    marginBottom: theme.spacing(1),
    color: theme.palette.primary.main,
  },
  title: {
    marginBottom: theme.spacing(3),
  },
  infoBox: {
    marginTop: theme.spacing(4),
    padding: theme.spacing(2),
    backgroundColor: theme.palette.background.default,
    borderRadius: theme.shape.borderRadius,
  }
}));

const LoginPage = ({ onLoginSuccess }) => {
  const classes = useStyles();
  const [apiKeyInput, setApiKeyInput] = useState('');
  const [showApiKey, setShowApiKey] = useState(false);
  const [error, setError] = useState('');
  const { saveApiKey } = useApiKey();

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Validação simples
    if (!apiKeyInput.trim()) {
      setError('Por favor, insira sua API Key para continuar.');
      return;
    }

    // Salvar a API Key no contexto e no localStorage
    try {
      saveApiKey(apiKeyInput.trim());
      
      // Chamar a função de callback para indicar login bem-sucedido
      if (onLoginSuccess) {
        onLoginSuccess();
      }
    } catch (error) {
      console.error('Erro ao salvar API Key:', error);
      setError('Ocorreu um erro ao processar sua solicitação. Por favor, tente novamente.');
    }
  };

  return (
    <Container component="main" maxWidth="md">
      <div className={classes.root}>
        <Paper elevation={3} className={classes.paper}>
          <LockOutlined className={classes.icon} />
          <Typography component="h1" variant="h5" className={classes.title}>
            Bem-vindo ao eLaw Xtractor
          </Typography>
          
          <Divider style={{ width: '100%', marginBottom: 20 }} />
          
          {error && (
            <Alert severity="error" style={{ width: '100%', marginBottom: 16 }}>
              {error}
            </Alert>
          )}
          
          <Typography variant="body1" align="center" paragraph>
            Para acessar as funcionalidades do sistema, insira sua API Key abaixo:
          </Typography>
          
          <form onSubmit={handleSubmit} style={{ width: '100%' }}>
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              id="apiKey"
              label="API Key"
              name="apiKey"
              autoFocus
              className={classes.formField}
              value={apiKeyInput}
              onChange={(e) => setApiKeyInput(e.target.value)}
              type={showApiKey ? 'text' : 'password'}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle api key visibility"
                      onClick={() => setShowApiKey(!showApiKey)}
                      edge="end"
                    >
                      {showApiKey ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              className={classes.submit}
            >
              Acessar o Sistema
            </Button>
          </form>
          
          <Box className={classes.infoBox}>
            <Typography variant="subtitle2" color="textSecondary" gutterBottom>
              Não possui uma API Key?
            </Typography>
            <Typography variant="body2" color="textSecondary">
              Entre em contato com o suporte técnico para obter sua chave de acesso.
              A API Key é necessária para utilizar todas as funcionalidades do sistema,
              incluindo o editor de templates e o processamento de documentos.
            </Typography>
          </Box>
        </Paper>
        
        <Grid container style={{ marginTop: 40 }}>
          <Grid item xs={12}>
            <Typography variant="caption" color="textSecondary" align="center" component="p">
              &copy; {new Date().getFullYear()} eLaw Xtractor. Todos os direitos reservados.
            </Typography>
          </Grid>
        </Grid>
      </div>
    </Container>
  );
};

export default LoginPage; 